import { trpc } from '@/shared/api';

/** 폰트 마스터 목록 조회 — 살아 있는 폰트만, 이름 오름차순. */
export const useFontsQuery = () => trpc.productManagement.fonts.list.useQuery();
